<template>
  <!-- <div class="scenery_options">
        <div class="scenery_span">
            <span>selecione o cenário:</span>
        </div>
        <div class="dropdown-container">
            <div class="dropdown-button" >
                <div class="button-toogle" @click="toogleDropdown()">
                    <span class="dropdown-text" >média global dos jogadores</span>
                    <div class="arrow_down"></div>
                </div>
                <div class="dropdown-list-container" v-if="dropdownOpen">
                    <ul class="dropdown-list">
                        <li class="list-item">Cenário 1</li>
                        <li class="list-item">Cenário 2</li>
                        <li class="list-item">Cenário 3</li>
                        <li class="list-item">Cenário 4</li>
                    </ul>
                </div>
            </div>
        </div>
  </div>-->
  <div
    class="scenery_options"
    :class="{ without_scenary: wsWithoutGlobal.includes(workspaceId) }"
    :style="{
            background: `${colors.backgrounds.solidLight}80`
        }"
  >
    <span>{{ $t("components.scenaryOptions.scenery_options") }}</span>
  </div>
</template>

<script>
export default {
  name: "ScenaryOptions",
  data: () => ({
    dropdownOpen: false,
    colors: "",
    workspaceId: '',
    wsWithoutGlobal: ["0BZuLEh5DpxoUaHW6vMz", "eBHsVn7mliHvdn7HpQ2w"]
  }),
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    this.workspaceId = JSON.parse(localStorage.getItem("report")).workspaceId
  },
  methods: {
    toogleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
	.scenery_options.without_scenary{
		span{
			visibility: hidden;
		}
	}
.scenery_options {
  height: 10vh;
  display: flex;
  justify-content: space-around;
  background-color: rgba($color: #02f0e4, $alpha: 0.3);

  span {
    font-size: 10px;
    color: #000;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    word-spacing: 1px;
  }
}
//     .scenery_options{
//         height: 10vh;
//         display: flex;
//         justify-content: space-around;
//         background-color: rgba($color: #02F0E4, $alpha: .3);

//         .scenery_span{
//             font-size: 10px;
//             color: #000;
//             font-weight: 700;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             width: 20%;
//             text-align: center;
//             text-transform: uppercase;
//             word-spacing: 5px;
//         }

//         .dropdown-container{

//             width: 80%;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             flex-direction: column;

//             .dropdown-button{

//                 height: 60%;
//                 width: 90%;
//                 border: none;
//                 background-color: #fff581;
//                 font-weight: bold;
//                 text-transform: uppercase;
//                 display: flex;
//                 align-items: center;
//                 justify-content: space-around;
//                 font-size: 10px;
//                 border-bottom: 5px solid #d8d365;
//                 position: relative;
//                 cursor: pointer;

//                 .button-toogle{

//                     width: 100%;
//                     display: flex;
//                     justify-content: space-around;
//                 }

//                 .arrow_down{
//                     width: 0;
//                     height: 0;
//                     border-right: 6px solid transparent;
//                     border-left: 6px solid transparent;
//                     border-top: 6px solid #000;
//                     // width: 10%
//                 }

//                 .dropdown-list-container{

//                     width: 100vh;
//                     background-color:  #d8d365;
//                     z-index: 10000;
//                     position: absolute;
//                     top: 100%;
//                     width: 100%;

//                     .dropdown-list{

//                         height: 100%;
//                         width: 100%;

//                         .list-item{
//                             width: 100%;
//                             height: 30px;
//                             display: flex;
//                             align-items: center;
//                             justify-content: center;
//                             background-color: #d8d365;

//                             &:hover{

//                                 background-color: #bdb962;
//                             }
//                         }
//                     }
//                 }
//             }
//         }
//     }

// @media only screen and (max-width: 500px){
//      .scenery_options{
//         .scenery_span{
//             font-size: 13px;
//             text-align: start;

//             span{
//                 padding-left: 15px;
//                 font-size: 10px;
//             }
//         }
//     }
// }

// @media only screen and (max-width: 360px){
//     .scenery_options{
//         .scenery_span{
//             font-size: 8px;

//             span{

//                 font-size: 8px;
//             }
//         }
//     }
// }
</style>


